import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

export default function useBugFeatureForm() {
  return useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });
}

export const BUG_FEATURE_TYPE = {
  BUG: 'Bug',
  FEATURE: 'Feature',
};

export const BUG_FEATURE_STATUS = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN-PROGRESS',
  CLOSED: 'CLOSED',
};

export const BUG_FEATURE_TYPE_LIST = Object.values(BUG_FEATURE_TYPE);

export const BUG_FEATURE_PRIORITY_LIST = ['Low', 'Medium', 'High', 'Critical'];

const defaultValues = {
  type: 'Bug',
  summary: '',
  description: '',
  priority: 'Low',
  impact: '',
  attachments: [],
};

const schema = yup.object().shape({
  type: yup
    .string()
    .oneOf(BUG_FEATURE_TYPE_LIST)
    .required()
    .label('Type'),
  summary: yup
    .string()
    .required()
    .label('Summary'),
  description: yup
    .string()
    .required()
    .label('Description'),
  priority: yup
    .string()
    .when('type', {
      is: 'Bug',
      then: yup.string().required(),
      otherwise: yup.string(),
    })
    .label('Priority'),
  impact: yup.string(),
  attachments: yup.array().label('Attachments'),
});

export const commonProps = ({ fieldState, field }) => {
  return {
    error: !!fieldState.error,
    value: field.value,
    helperTxt: fieldState.error?.message,
    onBlur: field.onBlur,
    onChange: field.onChange,
    name: field.name,
    id: `bug-feature-${field.name}`,
  };
};
